import * as React from "react";
import { FormField } from "./FormField.jsx";
// import * as cls from "./AutoTextBox.module.scss";
export { AutoTextBox }
/**
 * Текстовое поле ввода.
 *
 * Представляет элемент управления, который можно использовать для отображения
 * и редактирования обычного текста (однострочного или многострочного).
 * 
 * Автоматически увеличивает количество строк при вводе текста.
 * 
 * @summary Текстовое поле ввода с автоматическим увеличением количества строк.
 * @param {Object} props - Атрибуты элемента.
 * @param {React.RefObject} [props.inputRef] - Ссылка на элемент `input`.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.label] - Название и описание поля.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.required] - Обязательное для заполнения.
 * @param {boolean} [props.disabled] - Неактивно.
 * @param {boolean} [props.uncontrolled] - Неуправляемый компонент.
 * @param {boolean} [props.autoComplete] - Разрешено ли автозаполнение.
 * @param {string} [props.placeholder] - Отображать вместо пустого значения.
 * @param {int} [props.minLength] - Минимальное количество символов.
 * @param {int} [props.maxLength] - Максимальное количество символов.
 * @param {string} [props.value] - Значение.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {AutoTextBox} from "../personal-studio-components/form/index.js";
 * <AutoTextBox
 * 	 label="Введите текст"
 * 	 required={true}
 *   onChange={(event) => {console.log(event.target.value);}}/>
 * @see {@link ../frame/EventListener.js}
 * @see [Windows.UI.Xaml.Controls.TextBox](https://learn.microsoft.com/ru-ru/uwp/api/windows.ui.xaml.controls.textbox)
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function AutoTextBox(
  {
    inputRef,
    id,
    label,
    className,
    required,
    disabled,
    uncontrolled,
    autoComplete,
    placeholder,
    minLength,
    maxLength,
    value,
    onChange
  }) {
  return (
    <FormField
      label={label}
      labelFor={id}
      required={required}
      className={className}>
      <textarea
        rows={getRowCount(value)}
        ref={inputRef}
        id={id}
        name={id}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        placeholder={placeholder}
        minLength={minLength}
        maxLength={maxLength}
        value={uncontrolled ? undefined : (value ?? "")}
        onChange={onChangeTextArea} />
    </FormField>
  );
  function onChangeTextArea(event) {
    event.target.rows = getRowCount(event.target.value);
    if (onChange) onChange(event);
  }
}
// Количество строк в тексте
function getRowCount(text) {
  if (!text) return 1;
  return (String(text).match(/\n/g)?.length ?? 0) + 1;
}
